var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceCheckListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_188_1",
    "data-name": "Component 188 \\u2013 1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "check-circle",
    transform: "translate(0 24)",
    fill: "#1fba34",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 27,
    fontFamily: "FontAwesome5Free-Solid, 'Font Awesome \\\\\\\\35  Free'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "check-circle")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCheckListIcon);
export default __webpack_public_path__ + "static/media/price-check-list-icon.74a0dfbaec8e02c09daf6f39415bcda5.svg";
export { ForwardRef as ReactComponent };